// import {
//   Card,
//   CardTitle,
//   CardHeader,
//   CardBody,
//   FormGroup,
//   Form,
//   Input,
//   Row,
//   Col,
//   Table
// } from "reactstrap";
// import { toast } from 'react-toastify';

// import { useParams } from 'react-router-dom';
// import { useState, useEffect } from "react";
// import { useNavigate, Link } from 'react-router-dom';

// import { URL } from "../../api";
// import axiosInstance from "../../Request";
// import { isLoggedIn } from '../../util/common.js'


// import { fetchFoirData, updateFoirAccountObligation } from '../../services/customer.js'

// const Foir = (props) => {


//   const { cid, lid } = useParams();
//   const navigate = useNavigate();

//   const logged = isLoggedIn();
//   const [foirData, setFoirData] = useState([]);

//   const [obligation, setObligation] = useState(null);
//   const [dbr, setDBR] = useState(null);
//   const [max_emi, setMaxEmi] = useState(null);
//   const [this_emi, setThisLoanEmi] = useState(null);
//   const [editingRows, setEditingRows] = useState({});
//   const [max_dbr,] = useState(0);

//   const account_per = {
//     "10": 5
//   }


//   useEffect(() => {
//     if (!logged) {
//       navigate('/auth/login');
//     } else {
//       getFoirData();
//     }
//   }, [navigate, logged]);

//   useEffect(() => {
//     calculate_foir();
//   }, [foirData.accounts]);

//   useEffect(() => {
//     calculate_foir();
//   }, [editingRows]);


//   const handleEdit = (account) => {
//     let obl = account.obligation;
//     let per = account.obligation_per;
//     setEditingRows((prev) => ({
//       ...prev,
//       [account.id]: {
//         obligation_per: per,
//         obligation: obl,
//       },
//     }));
//   };

//   const handleChange = (id, field, value) => {
//     let obl = editingRows[id]["obligation"];
//     let per = editingRows[id]["obligation_per"];
//     if (field === "obligation") {
//       obl = value;
//       if (Number.isNaN(value) || value < 0) {
//         return false;
//       } else {
//         per = Math.round((Number(value) / foirData["accounts"][id]["sanction_amount"]) * 100);
//       }
//     } else if (field === "obligation_per") {
//       per = value;
//       if (Number.isNaN(value) || value < 0) {
//         return false;
//       } else {
//         obl = Math.round((foirData["accounts"][id]["sanction_amount"] * Number(value)) / 100);
//       }
//     }

//     setEditingRows((prev) => ({
//       ...prev,
//       [id]: {
//         ...prev[id],
//         ["obligation"]: obl,
//         ["obligation_per"]: per
//       },
//     }));

//     calculate_foir();
//   };

//   const handleSave = async (id) => {
//     let { obligation_per, obligation } = editingRows[id];

//     if (obligation_per === "" || Number.isNaN(obligation_per) || obligation_per < 0) {
//       toast.error("Please enter a number >= 0 ", {
//         autoClose: 4000,
//         position: "bottom-center",
//       });
//       return false;
//     }
//     if (obligation_per === "" || Number.isNaN(obligation) || obligation < 0) {
//       toast.error("Please enter a number >= 0 ", {
//         autoClose: 4000,
//         position: "bottom-center",
//       });
//       return false;
//     }
//     obligation = Number(obligation);
//     obligation_per = Number(obligation_per);

//     let post_data = {
//       leadId: lid,
//       customerId: cid,
//       bureauAccountId: id,
//       obligation: obligation,
//     }
//     await updateFoirObligationData(post_data, id, obligation, obligation_per);

//   };

//   const handleCancel = (id) => {
//     setEditingRows((prev) => {
//       const copy = { ...prev };
//       delete copy[id];
//       return copy;
//     });
//   };





//   const getFoirData = async () => {
//     try {


//       let data = {};
//       const response = await axiosInstance.get(`${URL.FOIR_DATA}?customer_id=${cid}&lead_id=${lid}`);
//       if (response.error) {
//         toast.error(response.error, {
//           autoClose: 4000,
//           position: "bottom-center",
//         });

//       } else {

//         let foir_data = response.data
//         if (foir_data && foir_data && foir_data.accounts && foir_data.accounts?.length > 0) {
//           const objectById = foir_data.accounts.reduce((acc, item) => {
//             let per_value = 3;
//             if (item.account_type_code in account_per) {
//               per_value = account_per[item.account_type_code]
//             }
//             const obligation = item.obligation ?? item.emi_amount ?? (item.sanction_amount * per_value / 100);

//             let per = Math.round((obligation / item["sanction_amount"]) * 100)
//             acc[item.id] = item;
//             acc[item.id]["obligation_per"] = per;
//             acc[item.id]["obligation"] = obligation;
//             return acc;
//           }, {});


//           foir_data.accounts = objectById;
//         }

//         setFoirData(foir_data);
//       }



//     } catch (error) {
//       toast.error("Error while fetching foir data. " + error.message, {
//         autoClose: 4000,
//         position: "bottom-center",
//       });

//     }
//   };


//   function calculate_foir() {
//     let obligation = 0;
//     if (foirData && foirData.accounts) {
//       Object.entries(foirData.accounts).forEach(([id, account]) => {
//         obligation += editingRows[id]?.obligation ?? account["obligation"] ?? 0;
//       });
//     }

//     if (foirData && foirData.active_loans) {
//       foirData.active_loans.forEach(item => {
//         obligation += item.emi_amount
//       });
//     }


//     let this_emi = 0;
//     let loan_amount = foirData.loan_details?.loanAmount ?? foirData.lead_details?.loanAmount ?? null;
//     let tenure = foirData.loan_details?.numberOfEmi ?? foirData.lead_details?.loanAmount ?? null;
//     let roi = foirData.loan_details?.roi ?? null;

//     if (loan_amount && tenure && roi) {
//       this_emi = Math.round(calculateEMI(loan_amount, roi * 12, tenure));
//     }

//     obligation += this_emi;

//     setThisLoanEmi(this_emi);

//     let salary = 0;

//     if (foirData.professional_details) {
//       salary = foirData.professional_details?.salary ?? (foirData.professional_details?.annualIncome / 12)
//       let dbr = Math.round((obligation / salary) * 100);


//       let max_emi = Math.round(((salary * max_dbr) / 100) - obligation);
//       setMaxEmi(max_emi);
//       setDBR(dbr);
//     }



//     setObligation(obligation);

//   }


//   const updateFoirObligationData = async (post_data, account_id, obl, obl_per) => {
//     const data = {
//       post_data: {
//         ...post_data
//       },
//       url: URL.UPDATE_FOIR_OBLIGATION
//     };
//     let status = "";
//     try {


//       updateFoirAccountObligation(data).then(response => {
//         if (response.response && response.response.status === 200) {
//           status = "success";


//           setEditingRows((prev) => {
//             const copy = { ...prev };
//             delete copy[account_id];
//             return copy;
//           });

//           setFoirData(prev => ({
//             ...prev,
//             accounts: {
//               ...prev.accounts,
//               [account_id]: {
//                 ...prev.accounts[account_id],
//                 obligation: obl,
//                 obligation_per: obl_per,
//               },
//             },
//           }));


//         } else {
//           status = "error";
//           console.error("Error saving obligation data...");

//           let msg = "Error saving obligation data !";
//           if (response.response) {
//             msg += "Status Code " + response.response.status
//           }

//           toast.error(msg, {
//             autoClose: 4000,
//             position: "bottom-center",
//           });
//         }
//       }).catch(error => {
//         status = "error";
//         console.error("Error saving obligation data..", error);

//         toast.error("Error saving obligation data " + error.message, {
//           autoClose: 4000,
//           position: "bottom-center",
//         });
//       });
//     } catch (error) {
//       status = "error";
//       console.error("Error saving obligation data: ", error);

//       toast.error("Error saving obligation data: " + error.message, {
//         autoClose: 4000,
//         position: "bottom-center",
//       });
//     }
//     return status;
//   };


//   function calculateEMI(principal, annualRate, months) {
//     const monthlyRate = annualRate / 12 / 100;
//     if (monthlyRate === 0) {
//       return principal / months;
//     }

//     const emi = (principal * monthlyRate * Math.pow(1 + monthlyRate, months)) /
//       (Math.pow(1 + monthlyRate, months) - 1);

//     return emi;
//   }

//   return (
//     <>

//       <Card className="bg-secondary shadow">
//         <CardHeader className="bg-white border-0">
//           <Row className="align-items-center">
//             <Col xs="8">
//               <h3 className="mb-0">Foir</h3>
//             </Col>
//           </Row>
//         </CardHeader>
//         <CardBody>


//           <Form>
//             <h6 className="heading-small text-muted mb-4">
//               Loan Details
//             </h6>
//             <div className="pl-lg-4">
//               <Row>
//                 <Col lg="6">
//                   <FormGroup>
//                     <label
//                       className="form-control-label"
//                       htmlFor="input-first-name"
//                     >
//                       Loan Amount
//                     </label>
//                     <Input
//                       className="form-control-alternative"
//                       id="input-first-name"
//                       placeholder="Loan Amount"
//                       type="number"
//                       disabled="1"
//                       value={
//                         foirData.loan_details?.loanAmount ?? foirData.lead_details?.loanAmount ?? ''
//                       }
//                     />
//                   </FormGroup>
//                 </Col>

//                 <Col lg="6">
//                   <FormGroup>
//                     <label
//                       className="form-control-label"
//                       htmlFor="input-first-name"
//                     >
//                       Tenure
//                     </label>
//                     <Input
//                       className="form-control-alternative"
//                       id="input-first-name"
//                       placeholder="Tenure"
//                       type="number"
//                       disabled="1"
//                       value={
//                         foirData.loan_details?.numberOfEmi ?? foirData.lead_details?.numberOfEmi ?? ''
//                       }
//                     />
//                   </FormGroup>
//                 </Col>

//                 <Col lg="6">
//                   <FormGroup>
//                     <label
//                       className="form-control-label"
//                       htmlFor="input-first-name"
//                     >
//                       ROI
//                     </label>
//                     <Input
//                       className="form-control-alternative"
//                       id="input-first-name"
//                       placeholder="ROI"
//                       type="number"
//                       disabled="1"
//                       value={
//                         foirData.loan_details?.roi ?? ''
//                       }
//                     />
//                   </FormGroup>
//                 </Col>

//                 <Col lg="6">
//                   <FormGroup>
//                     <label
//                       className="form-control-label"
//                       htmlFor="input-first-name"
//                     >
//                       Emi
//                     </label>
//                     <Input
//                       className="form-control-alternative"
//                       id="input-emi"
//                       placeholder="Emi"
//                       type="number"
//                       disabled="1"
//                       value={this_emi}
//                     />
//                   </FormGroup>
//                 </Col>

//                 <Col lg="6">
//                   <FormGroup>
//                     <label
//                       className="form-control-label"
//                       htmlFor="input-first-name"
//                     >
//                       Salary
//                     </label>
//                     <Input
//                       className="form-control-alternative"
//                       id="input-first-name"
//                       placeholder="Salary"
//                       type="number"
//                       disabled="1"
//                       value={
//                         foirData.professional_details?.salary ?? (foirData.professional_details?.annualIncome / 12) ?? ''
//                       }
//                     />
//                   </FormGroup>
//                 </Col>



//                 <Col lg="6">
//                   <FormGroup>
//                     <label
//                       className="form-control-label"
//                       htmlFor="input-first-name"
//                     >
//                       Max dbr
//                     </label>
//                     <Input
//                       className="form-control-alternative"
//                       id="input-emi"
//                       placeholder="Emi"
//                       type="number"
//                       disabled="1"
//                       value={max_dbr}
//                     />
//                   </FormGroup>
//                 </Col>

//               </Row>
//             </div>

//           </Form>

//           <hr className="my-4" />

//           <h6 className="heading-small text-muted mb-4">
//             Other Active Loans
//           </h6>
//           <div className="pl-lg-4">
//             <Row>
//               <Col lg="12">
//                 <Table className="align-items-center table-flush" responsive>
//                   <thead className="thead-light">
//                     <tr>
//                       <th scope="col">Lead ID</th>
//                       <th scope="col">Approved Amount</th>
//                       <th scope="col">Outstanding Principal</th>
//                       <th scope="col">Emi Amount</th>
//                     </tr>
//                   </thead>
//                   <tbody>

//                     {foirData.active_loans?.length > 0 ? (
//                       foirData.active_loans.map((loan) => (
//                         <tr key={loan.id}>
//                           <td><Link target="_blank" to={`/customer/detail/${cid}/${loan.lead_id}`}>{loan.lead_id}</Link></td>
//                           <td>{loan.loan_amount}</td>
//                           <td>{loan.outstanding_principal}</td>
//                           <td>{loan.emi_amount}</td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="4">No active Loans found</td>
//                       </tr>
//                     )}






//                   </tbody>
//                 </Table>


//               </Col>





//             </Row>
//           </div>

//           <hr className="my-4" />


//           <div className="pl-lg-4">
//             <Row>
//               <Col md="4">
//                 <Card className="card-stats mb-4 mb-xl-0">
//                   <CardBody>
//                     <Row>
//                       <div className="col">
//                         <CardTitle
//                           tag="h5"
//                           className="text-uppercase text-muted mb-0"
//                         >
//                           DBR
//                         </CardTitle>
//                         <span className={`h2 font-weight-bold mb-0 ${dbr > max_dbr ? 'text-danger' : 'text-success'}`}>
//                           {dbr + "%" ?? "-"}
//                         </span>
//                       </div>
//                     </Row>

//                   </CardBody>
//                 </Card>
//               </Col>
//               <Col md="4">
//                 <Card className="card-stats mb-4 mb-xl-0">
//                   <CardBody>
//                     <Row>
//                       <div className="col">
//                         <CardTitle
//                           tag="h5"
//                           className="text-uppercase text-muted mb-0"
//                         >
//                           Obligation
//                         </CardTitle>
//                         <span className={`h2 font-weight-bold mb-0 ${dbr > max_dbr ? 'text-danger' : 'text-success'}`}>
//                           {obligation ?? "-"}
//                         </span>
//                       </div>
//                     </Row>
//                   </CardBody>
//                 </Card>
//               </Col>

//               <Col md="4">

//                 <Card className="card-stats mb-4 mb-xl-0">
//                   <CardBody>
//                     <Row>
//                       <div className="col">
//                         <CardTitle
//                           tag="h5"
//                           className="text-uppercase text-muted mb-0"
//                         >
//                           Max-Emi
//                         </CardTitle>
//                         <span className={`h2 font-weight-bold mb-0 ${dbr > max_dbr ? 'text-danger' : 'text-success'}`}>
//                           {max_emi ?? "-"}
//                         </span>
//                       </div>
//                     </Row>

//                   </CardBody>
//                 </Card>
//               </Col>


//             </Row>
//           </div>

//           <hr className="my-4" />

//           <h6 className="heading-small text-muted mb-4">
//             Bureau Obligation
//           </h6>
//           <div className="pl-lg-4">
//             <Row>
//               <Col lg="12">
//                 <Table className="align-items-center table-flush" responsive>
//                   <thead className="thead-light">
//                     <tr>
//                       <th scope="col">Account Type</th>
//                       <th scope="col">DPD</th>
//                       <th scope="col">High Credit/Sanctioned Amount</th>
//                       <th scope="col">Current Balance</th>
//                       <th scope="col">Obligation %</th>
//                       <th scope="col">Obligation</th>
//                       <th scope="col">Action</th>
//                     </tr>
//                   </thead>
//                   <tbody>

//                     {foirData.accounts ? (

//                       Object.entries(foirData.accounts).map(([id, account]) => {
//                         const isEditing = !!editingRows[account.id];

//                         const obligation = editingRows[account.id]?.obligation ?? account.obligation;

//                         const obligation_per = editingRows[account.id]?.obligation_per ?? account.obligation_per ?? 0;

//                         return (
//                           <tr key={id}>
//                             <td>{account.account_type}</td>
//                             <td>{account.dpd_char}</td>
//                             <td>{account.sanction_amount ?? account.line_limit}</td>
//                             <td>{account.balance}</td>
//                             <td>{isEditing ? (
//                               <input
//                                 type="number"
//                                 value={obligation_per}
//                                 onChange={(e) => handleChange(account.id, 'obligation_per', e.target.value)}
//                               />
//                             ) : (
//                               obligation_per
//                             )}</td>
//                             <td>
//                               {isEditing ? (
//                                 <input
//                                   type="number"
//                                   value={obligation}
//                                   onChange={(e) => handleChange(account.id, 'obligation', e.target.value)}
//                                 />
//                               ) : (
//                                 obligation
//                               )}
//                               {/* {account.obligation ?? account.emi_amount ?? (account.sanction_amount * 5/ 100)} */}

//                             </td>
//                             <td>
//                               {isEditing ? (
//                                 <>
//                                   <a href="#" onClick={(e) => { e.preventDefault(); handleSave(account.id); }}>Save</a> |{' '}
//                                   <a href="#" onClick={(e) => { e.preventDefault(); handleCancel(account.id); }}>Cancel</a>
//                                 </>
//                               ) : (
//                                 <a href="#" onClick={(e) => { e.preventDefault(); handleEdit(account); }}>Edit</a>
//                               )}
//                             </td>
//                           </tr>
//                         )
//                       }
//                       )
//                     ) : (
//                       <tr>
//                         <td colSpan="7">No Bureau Accounts</td>
//                       </tr>
//                     )}

//                   </tbody>
//                 </Table>


//               </Col>





//             </Row>
//           </div>





//         </CardBody>
//       </Card>


//     </>
//   );
// };

// export default Foir;



// import {
//   Card,
//   CardTitle,
//   CardHeader,
//   CardBody,
//   FormGroup,
//   Form,
//   Input,
//   Row,
//   Col,
//   Table
// } from "reactstrap";
// import { toast } from 'react-toastify';

// import { useParams } from 'react-router-dom';
// import { useState, useEffect } from "react";
// import { useNavigate, Link } from 'react-router-dom';

// import { URL } from "../../api";
// import axiosInstance from "../../Request";
// import { isLoggedIn } from '../../util/common.js';

// import { updateFoirAccountObligation } from '../../services/customer.js';

// const Foir = () => {
//   const { cid, lid } = useParams();
//   const navigate = useNavigate();
//   const logged = isLoggedIn();

//   const [foirData, setFoirData] = useState([]);
//   const [foirCalc, setFoirCalc] = useState(null);
//   const [editingRows, setEditingRows] = useState({});
//   const [max_dbr] = useState(90);

//   const account_per = {
//     "10": 5
//   };

//   useEffect(() => {
//     if (!logged) {
//       navigate('/auth/login');
//     } else {
//       getFoirData();
//     }
//   }, [navigate, logged]);

//   useEffect(() => {
//     fetchFoirCalculatedData();
//   }, [foirData.accounts, editingRows]);

//   const getFoirData = async () => {
//     try {
//       const response = await axiosInstance.get(`${URL.FOIR_DATA}?customer_id=${cid}&lead_id=${lid}`);
//       if (response.error) {
//         toast.error(response.error, {
//           autoClose: 4000,
//           position: "bottom-center",
//         });
//       } else {
//         let foir_data = response.data;
//         if (foir_data && foir_data.accounts?.length > 0) {
//           const objectById = foir_data.accounts.reduce((acc, item) => {
//             let per_value = 3;
//             if (item.account_type_code in account_per) {
//               per_value = account_per[item.account_type_code];
//             }
//             const obligation = item.obligation ?? item.emi_amount ?? (item.sanction_amount * per_value / 100);
//             let per = Math.round((obligation / item["sanction_amount"]) * 100);
//             acc[item.id] = item;
//             acc[item.id]["obligation_per"] = per;
//             acc[item.id]["obligation"] = obligation;
//             return acc;
//           }, {});
//           foir_data.accounts = objectById;
//         }
//         setFoirData(foir_data);
//       }
//     } catch (error) {
//       toast.error("Error while fetching foir data. " + error.message, {
//         autoClose: 4000,
//         position: "bottom-center",
//       });
//     }
//   };

//   const fetchFoirCalculatedData = async () => {
//     try {
//       const response = await axiosInstance.get(`${URL.CALCULATE_FOIR}?customer_id=${cid}&lead_id=${lid}`);
//       if (response.data) {
//         setFoirCalc(response.data);
//       }
//     } catch (error) {
//       toast.error("Error fetching FOIR calculation: " + error.message, {
//         autoClose: 4000,
//         position: "bottom-center",
//       });
//     }
//   };

//   const handleEdit = (account) => {
//     setEditingRows((prev) => ({
//       ...prev,
//       [account.id]: {
//         obligation_per: account.obligation_per,
//         obligation: account.obligation,
//       },
//     }));
//   };

//   const handleChange = (id, field, value) => {
//     let obligation = editingRows[id]?.obligation;
//     let obligation_per = editingRows[id]?.obligation_per;
//     const sanctionAmount = foirData.accounts[id]?.sanction_amount || 1;
//     if (field === 'obligation') {
//       obligation = Number(value);
//       obligation_per = Math.round((obligation / sanctionAmount) * 100);
//     } else if (field === 'obligation_per') {
//       obligation_per = Number(value);
//       obligation = Math.round((sanctionAmount * obligation_per) / 100);
//     }
//     if (isNaN(obligation) || isNaN(obligation_per)) return;
//     setEditingRows((prev) => ({
//       ...prev,
//       [id]: { obligation, obligation_per },
//     }));
//   };

//   const handleSave = async (id) => {
//     const { obligation, obligation_per } = editingRows[id];
//     if (isNaN(obligation) || obligation < 0 || isNaN(obligation_per) || obligation_per < 0) {
//       toast.error("Invalid input", { autoClose: 4000, position: "bottom-center" });
//       return;
//     }
//     const post_data = {
//       leadId: lid,
//       customerId: cid,
//       bureauAccountId: id,
//       obligation: obligation,
//     };
//     try {
//       const response = await updateFoirAccountObligation({ post_data, url: URL.UPDATE_FOIR_OBLIGATION });
//       if (response.response && response.response.status === 200) {
//         setFoirData(prev => ({
//           ...prev,
//           accounts: {
//             ...prev.accounts,
//             [id]: {
//               ...prev.accounts[id],
//               obligation,
//               obligation_per,
//             },
//           },
//         }));
//         setEditingRows(prev => {
//           const updated = { ...prev };
//           delete updated[id];
//           return updated;
//         });
//       } else {
//         throw new Error("API error");
//       }
//     } catch (error) {
//       toast.error("Error saving obligation data: " + error.message, { autoClose: 4000, position: "bottom-center" });
//     }
//   };

//   const handleCancel = (id) => {
//     setEditingRows(prev => {
//       const updated = { ...prev };
//       delete updated[id];
//       return updated;
//     });
//   };

//   return (
//     <>
//       {/* Render UI using foirCalc.dbr, foirCalc.salary, foirCalc.max_emi, foirCalc.obligations */}
//     </>
//   );
// };

// export default Foir;

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "../../Request";
import { URL } from "../../api";
import { toast } from "react-toastify";

const Foir = () => {
  const { cid, lid } = useParams();
  const [foirData, setFoirData] = useState({});
  const [foirSummary, setFoirSummary] = useState({});
  const [editing, setEditing] = useState({});

  useEffect(() => {
    fetchFoirData();
    fetchFoirSummary(); // fetch /foir/calculate
  }, []);

  const fetchFoirData = async () => {
    try {
      const res = await axiosInstance.get(`${URL.GET_FOIR_DATA}?customer_id=${cid}&lead_id=${lid}`);
      setFoirData(res.data || {});
    } catch (error) {
      toast.error("Failed to fetch FOIR data");
    }
  };

  const fetchFoirSummary = async () => {
    try {
      const res = await axiosInstance.get(`${URL.FOIR_CALCULATE}?customer_id=${cid}&lead_id=${lid}`);
      setFoirSummary(res.data || {});
    } catch (error) {
      toast.error("Failed to fetch FOIR summary");
    }
  };

  const handleEdit = (id) => {
    const row = foirData.accounts[id];
    setEditing({
      ...editing,
      [id]: {
        obligation: row.obligation,
        obligationPer: row.obligationPer,
      },
    });
  };

  const handleChange = (id, field, value) => {
    setEditing({
      ...editing,
      [id]: {
        ...editing[id],
        [field]: value,
      },
    });
  };

  const handleSave = async (id) => {
    const data = editing[id];
    try {
      await axiosInstance.put(URL.UPDATE_OBLIGATION, {
        customer_id: cid,
        lead_id: lid,
        account_id: id,
        obligation: Number(data.obligation),
        obligation_per: Number(data.obligationPer),
      });

      toast.success("Updated successfully");

      const updatedAccounts = {
        ...foirData.accounts,
        [id]: {
          ...foirData.accounts[id],
          obligation: Number(data.obligation),
          obligationPer: Number(data.obligationPer),
        },
      };

      setFoirData({ ...foirData, accounts: updatedAccounts });

      const newEditing = { ...editing };
      delete newEditing[id];
      setEditing(newEditing);

      fetchFoirSummary(); // refresh summary after update
    } catch (err) {
      toast.error("Update failed");
    }
  };

  const renderHeaderCards = () => (
    <div className="row mb-4">
      <div className="col-md-4">
        <div className="p-3 bg-light rounded shadow-sm text-center">
          <h6>DBR</h6>
          <h4 className="text-danger">{foirSummary.dbr_str || "-"}%</h4>
        </div>
      </div>
      <div className="col-md-4">
        <div className="p-3 bg-light rounded shadow-sm text-center">
          <h6>OBLIGATION</h6>
          <h4 className="text-danger">{foirSummary.obligations || 0}</h4>
        </div>
      </div>
      <div className="col-md-4">
        <div className="p-3 bg-light rounded shadow-sm text-center">
          <h6>MAX EMI</h6>
          <h4 className="text-danger">{foirSummary.max_emi || 0}</h4>
        </div>
      </div>
    </div>
  );

  return (
    <div className="container mt-4">
      <h3 className="mb-3">Bureau Obligation</h3>

      {renderHeaderCards()}

      <table className="table table-bordered table-striped table-sm">
        <thead className="thead-light">
          <tr>
            <th>Account Type</th>
            <th>DPD</th>
            <th>High Credit/Sanctioned Amount</th>
            <th>Current Balance</th>
            <th>Obligation %</th>
            <th>Obligation</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {foirData.accounts &&
            Object.entries(foirData.accounts).map(([id, acc]) => {
              const isEdit = editing[id];
              return (
                <tr key={id}>
                  <td>{acc.type}</td>
                  <td>000</td>
                  <td>{acc.sanctionAmount}</td>
                  <td>{acc.balance}</td>
                  <td>
                    {isEdit ? (
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        value={isEdit.obligationPer}
                        onChange={(e) =>
                          handleChange(id, "obligationPer", e.target.value)
                        }
                      />
                    ) : (
                      acc.obligationPer
                    )}
                  </td>
                  <td>
                    {isEdit ? (
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        value={isEdit.obligation}
                        onChange={(e) =>
                          handleChange(id, "obligation", e.target.value)
                        }
                      />
                    ) : (
                      acc.obligation
                    )}
                  </td>
                  <td>
                    {isEdit ? (
                      <button
                        className="btn btn-sm btn-success"
                        onClick={() => handleSave(id)}
                      >
                        Save
                      </button>
                    ) : (
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() => handleEdit(id)}
                      >
                        Edit
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

export default Foir;


